import * as v from 'valibot';
import { ieeeSchema, integerInRange, nwkSchema } from '../../util/valibot';
export const neighborInputSchema = v.object({
    depth: integerInRange(0, 0xffff),
    device_type: v.union([v.literal('coordinator'), v.literal('router'), v.literal('end device'), v.literal('reserved')]),
    permit_joining: v.union([v.literal('no'), v.literal('yes'), v.literal('unknown1'), v.literal('unknown2')]),
    rx_when_idle: v.union([v.literal('on'), v.literal('off'), v.literal('unknown1'), v.literal('unknown2')]),
    relationship: v.union([
        v.literal('parent'),
        v.literal('child'),
        v.literal('sibling'),
        v.literal('none'),
        v.literal('previous child'),
        v.literal('unknown1'),
        v.literal('unknown2'),
        v.literal('unknown3')
    ]),
    ieee: ieeeSchema,
    nwk: nwkSchema,
    epan: v.string(),
    lqi: integerInRange(0, 0xffff)
});
export const neighborSchema = v.pipe(neighborInputSchema, v.transform((o) => ({
    depth: o.depth,
    deviceType: o.device_type,
    permitJoining: o.permit_joining,
    rxWhenIdle: o.rx_when_idle,
    relationship: o.relationship,
    ieee: o.ieee,
    nwk: o.nwk,
    extendedPAN: o.epan,
    lqi: o.lqi
})));
